module.exports = __webpack_public_path__ + "img/1254938466.4e54d92c.jpg";